import { useAppContext } from '../../contexts/AppContext';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import Map from '../common/Map';
import { fieldRegistry } from './fieldRegistry';
import { isFieldHidden } from './fieldVisibility';
import { useFormRendererContext } from './FormRendererContext';
import GroupField from './GroupField';
import ListField from './ListField';
import ToggleGroupField from './ToggleGroupField';
import SoilingSensorDataSection from './SoilingSensorDataSection';
import type { FieldSchema } from './types';

interface FieldRendererProps {
  field: FieldSchema;
}

const FieldRenderer = ({ field }: FieldRendererProps) => {
  const { role } = useAppContext();
  const { getFormDataItem } = useFormContext();
  const formData = useFormData();
  const { mapRef } = useFormRendererContext();

  if (field?.hidden) {
    return null;
  }
  if (isFieldHidden(field, formData, getFormDataItem)) {
    return null;
  }
  if (Object.prototype.hasOwnProperty.call(field, 'roles') && !field.roles!.includes(role)) {
    return null;
  }

  switch (field.type) {
    case 'map':
      return <Map mapRef={mapRef} field={field} />;
    case 'list':
      return <ListField field={field} />;
    case 'group':
      return field.name === 'soiling_sensor_data' ? <SoilingSensorDataSection field={field} /> : <GroupField field={field} />;
    case 'toggleGroupForm':
      return <ToggleGroupField field={field} />;
    default: {
      const Component = fieldRegistry[field.type];
      return Component ? <Component field={field} /> : null;
    }
  }
};

export default FieldRenderer;
